{
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.0.2",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 150,
	"w": 300,
	"h": 300,
	"nm": "Success-300x300",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Check mark black",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [155, 140, 0], "ix": 2 },
				"a": { "a": 0, "k": [11.59, -32.989, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[-27.503, 3.746],
										[3.5, 3.5],
										[3.057, -68.646]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 45, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0.101960784314, 0.101960784314, 0.101960784314, 1
						],
						"ix": 3
					},
					"o": { "a": 0, "k": 100, "ix": 4 },
					"w": { "a": 0, "k": 15, "ix": 5 },
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				},
				{
					"ty": "tm",
					"s": { "a": 0, "k": 0, "ix": 1 },
					"e": { "a": 0, "k": 100, "ix": 2 },
					"o": { "a": 0, "k": 0, "ix": 3 },
					"m": 1,
					"ix": 3,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 55,
			"op": 150,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "BG white",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": { "a": 0, "k": 0, "ix": 1 },
							"e": { "a": 0, "k": 100, "ix": 2 },
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "fl",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 55,
			"op": 150,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Check mark",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [155, 140, 0], "ix": 2 },
				"a": { "a": 0, "k": [11.59, -32.989, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0],
										[0, 0]
									],
									"v": [
										[-27.503, 3.746],
										[3.5, 3.5],
										[3.057, -68.646]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 45, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "st",
					"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
					"o": { "a": 0, "k": 100, "ix": 4 },
					"w": { "a": 0, "k": 15, "ix": 5 },
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				},
				{
					"ty": "tm",
					"s": { "a": 0, "k": 0, "ix": 1 },
					"e": {
						"a": 1,
						"k": [
							{
								"i": { "x": [0.667], "y": [1] },
								"o": { "x": [0.167], "y": [0.167] },
								"t": 31,
								"s": [0]
							},
							{
								"i": { "x": [0.667], "y": [1] },
								"o": { "x": [0.167], "y": [0.167] },
								"t": 32,
								"s": [1]
							},
							{ "t": 39, "s": [100] }
						],
						"ix": 2
					},
					"o": { "a": 0, "k": 0, "ix": 3 },
					"m": 1,
					"ix": 3,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 55,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "stroke",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [155, 140, 0], "ix": 2 },
				"a": { "a": 0, "k": [11.59, -32.989, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[0, 0],
										[0, 0]
									],
									"o": [
										[0, 0],
										[0, 0]
									],
									"v": [
										[-125.791, 5.16],
										[3.5, 3.5]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [98.145, 96.179], "ix": 3 },
							"r": { "a": 0, "k": 45, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Shape 1",
					"np": 1,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "st",
					"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
					"o": { "a": 0, "k": 100, "ix": 4 },
					"w": { "a": 0, "k": 15, "ix": 5 },
					"lc": 2,
					"lj": 1,
					"ml": 4,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": { "x": [0.667], "y": [1] },
								"o": { "x": [0.167], "y": [0.167] },
								"t": 35,
								"s": [0]
							},
							{ "t": 39, "s": [100] }
						],
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": { "x": [0.667], "y": [1] },
								"o": { "x": [0.167], "y": [0.167] },
								"t": 27,
								"s": [0]
							},
							{
								"i": { "x": [0.667], "y": [1] },
								"o": { "x": [0.167], "y": [0.167] },
								"t": 28,
								"s": [1]
							},
							{ "t": 35, "s": [100] }
						],
						"ix": 2
					},
					"o": { "a": 0, "k": 0, "ix": 3 },
					"m": 1,
					"ix": 3,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 55,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "outline",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": -58, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [-60.9, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 3,
										"s": [0]
									},
									{ "t": 26, "s": [100] }
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 7,
										"s": [0]
									},
									{ "t": 36, "s": [100] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 24, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 55,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "outline red",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": -58, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [-60.9, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 3,
										"s": [0]
									},
									{ "t": 26, "s": [100] }
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": { "x": [0.667], "y": [1] },
										"o": { "x": [0.333], "y": [0] },
										"t": 10,
										"s": [0]
									},
									{ "t": 36, "s": [100] }
								],
								"ix": 2
							},
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.890196078431, 0.137254901961,
									0.125490196078, 1
								],
								"ix": 3
							},
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 22, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 55,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "BG",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": { "a": 0, "k": [150, 150, 0], "ix": 2 },
				"a": { "a": 0, "k": [-20, -4, 0], "ix": 1 },
				"s": { "a": 0, "k": [60.914, 60.914, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"d": 1,
							"ty": "el",
							"s": { "a": 0, "k": [382.5, 382.5], "ix": 2 },
							"p": { "a": 0, "k": [0, 0], "ix": 3 },
							"nm": "Ellipse Path 1",
							"mn": "ADBE Vector Shape - Ellipse",
							"hd": false
						},
						{
							"ty": "tm",
							"s": { "a": 0, "k": 0, "ix": 1 },
							"e": { "a": 0, "k": 100, "ix": 2 },
							"o": { "a": 0, "k": 360, "ix": 3 },
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.133333333333, 0.133333333333,
									0.133333333333, 1
								],
								"ix": 4
							},
							"o": { "a": 0, "k": 100, "ix": 5 },
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [-20, -4], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform"
						}
					],
					"nm": "Ellipse 1",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 55,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
}
